// extracted by mini-css-extract-plugin
module.exports = {"MainUtp":"MainUtp_MainUtp__2stIv","item":"MainUtp_item__16K5W","img":"MainUtp_img__3GG9r","title":"MainUtp_title__rVoTU","active":"MainUtp_active__OnttP"};